import { NavBarBtnModel } from 'common/src/models';
import { ButtonDropdownActionsModel } from 'common/src/models/nav-bar-btn.model';
import { ContextMenuItemAction, ContextMenuItemModel } from 'common/src/models/context-menu.model';
import { MenuPanelItemModel } from '../components';

function toMenuPanelItems(actions: ButtonDropdownActionsModel[]): MenuPanelItemModel[] {
  return (actions || []).map(a => ({ id: a.actionName as string, label: a.actionTitle, icon: a.actionIcon, disabled: a.disabled }));
}

function filterActionsByStatus(actions: ButtonDropdownActionsModel[], status?: string): ButtonDropdownActionsModel[] {
  return (actions || []).filter(a => (!a.hideWithStatus || !a.hideWithStatus.includes(status)) && !a.hideAction);
}

const OPEN_CONTEXT_MENU_ITEM: MenuPanelItemModel = { id: 'openDocument', label: 'BUTTON.OPEN_LINK', icon: 'arrow-right' };

function joinSections(sections: MenuPanelItemModel[][]): MenuPanelItemModel[] {
  const nonEmpty = sections.filter(section => section.length);
  return nonEmpty.reduce((acc, section, i) => {
    const isLast = i === nonEmpty.length - 1;
    const withDivider = isLast
      ? section
      : section.map((item, j) => j === section.length - 1 ? { ...item, dividerAfter: true } : item);
    return [...acc, ...withDivider];
  }, [] as MenuPanelItemModel[]);
}

export function buildRowContextMenuItems(
  footer: NavBarBtnModel[],
  editActions: ContextMenuItemModel[],
  isEditingOnly: boolean,
  customActions: MenuPanelItemModel[] = [],
  status?: string,
  includeOpen: boolean = true,
): MenuPanelItemModel[] {
  const moreBtn = footer.find(btn => btn.isMoreAction);
  const sendEmailBtn = footer.find(btn => btn.actionName === ContextMenuItemAction.SEND_EMAIL);

  const moreFromFooter = moreBtn ? toMenuPanelItems(filterActionsByStatus(moreBtn.actions, status)) : [];
  const editItems: MenuPanelItemModel[] = isEditingOnly
    ? []
    : (editActions || []).map(a => ({ id: a.action, label: 'BUTTON.EDIT', icon: a.icon, disabled: a.disabled }));

  const moreSection = [...(includeOpen ? [OPEN_CONTEXT_MENU_ITEM] : []), ...editItems, ...moreFromFooter];

  const exportSection = sendEmailBtn ? toMenuPanelItems(filterActionsByStatus(sendEmailBtn.actions, status)) : [];

  const otherSection = footer
    .filter(btn => btn !== moreBtn && btn !== sendEmailBtn)
    .reduce((acc, btn) => [
      ...acc,
      ...((btn.actions && btn.actions.length)
        ? toMenuPanelItems(filterActionsByStatus(btn.actions, status))
        : toMenuPanelItems([{ actionTitle: btn.text, actionName: btn.actionName, actionIcon: btn.iconName, disabled: btn.disabled }])),
    ], [] as MenuPanelItemModel[]);

  if (!moreBtn && !sendEmailBtn) {
    return [...moreSection, ...otherSection, ...customActions];
  }

  return joinSections([moreSection, exportSection, otherSection, customActions]);
}
